import { render, staticRenderFns } from "./MarqueeSlider.vue?vue&type=template&id=16a24676&"
import script from "./MarqueeSlider.vue?vue&type=script&lang=js&"
export * from "./MarqueeSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports